import { TenantPackageConfig } from '~/tenants/common/registry';
import { MlmOrderContext, MlmOrderType } from '~/tenants/mlm/model/MlmOrder';
import MlmPhotosConfig from '~/tenants/mlm/performable/photos/MlmPhotosConfig';
import MlmFloorplanConfig from '~/tenants/mlm/performable/floorplan/MlmFloorplanConfig';

const MlmStarterPackageConfig: TenantPackageConfig = {
  id: 'starter',
  name: 'Digital Starter Add-on',
  description: '',
  amount: '40.00',
  performables: [MlmPhotosConfig, MlmFloorplanConfig],
  eligible: (context) => (context as MlmOrderContext).metadata.type === MlmOrderType.RESIDENTIAL,
};

export default MlmStarterPackageConfig;
